import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import { Field, reduxForm } from 'redux-form';
import {validate, isInRange} from '../../scripts/DateRangeYearOnlyValidation.js';

//import components
import DateRangeField from './DateRangeField.js';
import DateRangeFieldCheckbox from './DateRangeFieldCheckbox.js';

const DateRangeYearOnly = ({handleSubmit, min, max, isSelected, submitting, pristine, reset, clang, mask, error, submitFailed, dirty, valid, invalid, setOpenedFilter}) => {
    return (
        <div className="date-range">
            <form onSubmit={handleSubmit}>
                <div className="date-range__date-fields">
                    <Field
                        name="from"
                        type="text"
                        component={DateRangeField}
                        mask={mask}
                        label={lang[clang].results.date_from}
                        placeholder={lang[clang].results.year_placeholder}
                        validate={[isInRange]}/>
                    {(!min || min < 0) &&
                        <Field
                            name="fromBc"
                            component={DateRangeFieldCheckbox}
                            label={lang[clang].results.bc}/>}
                    <div className="date-range__separator">-</div>
                    <Field
                        name="to"
                        type="password"
                        mask={mask}
                        component={DateRangeField}
                        label={lang[clang].results.date_to}
                        placeholder={lang[clang].results.year_placeholder}
                        validate={[isInRange]}/>
                    {(!max || max < 0) &&
                        <Field
                          name="toBc"
                          component={DateRangeFieldCheckbox}
                          label={lang[clang].results.bc}/>}
                </div>

                <div className="filter__submit-container">
                    {((error && submitFailed) || (dirty && invalid)) &&
                        <span className="date-range__form-error">{lang[clang].date_range[error]}</span>}
                    {valid && (dirty || !isSelected) &&
                        <button
                            type="submit"
                            disabled={submitting}
                            className="filter__submit active">
                            {lang[clang].results.submit}
                        </button>}
                    {((invalid) || (pristine && isSelected) ) &&
                        <button
                            type="button"
                            onClick={() => setOpenedFilter(null)}
                            className={`filter__submit`}>
                            {lang[clang].results.close}
                        </button>}
                </div>
            </form>
        </div>
    );
};

DateRangeYearOnly.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    validate
})(DateRangeYearOnly));



// WEBPACK FOOTER //
// ./src/components/date-range/DateRangeYearOnly.js